// src/api/menu.js
import axios from 'axios';

const API = '/api';

export const menuApi = {
    // Админские
    getItems: (config) => axios.get(`${API}/admin/menu/items`, config),
    createItem: (data, config) => axios.post(`${API}/admin/menu/items`, data, config),
    updateItem: (id, data, config) => axios.patch(`${API}/admin/menu/items/${id}`, data, config),
    deleteItem: (id, config) => axios.delete(`${API}/admin/menu/items/${id}`, config),
    getCounters: (config) => axios.get(`${API}/admin/menu/counters`, config),
    getMemberTags: (config) => axios.get(`${API}/admin/menu/tags`, config),
    exportSelections: (config) => axios.get(`${API}/admin/menu/export`, {responseType: 'blob', ...config}),
    saveMemberSelection: (memberId, data, config) => axios.put(`${API}/admin/menu/selections/${memberId}`, data, config),
    clearMemberSelection: (memberId, config) => axios.delete(`${API}/admin/menu/selections/${memberId}`, config),
    getSettings: (config) => axios.get(`${API}/admin/menu/settings`, config),
    updateSettings: (data, config) => axios.put(`${API}/admin/menu/settings`, data, config),

    // Публичные
    getStatus: (token, config) => axios.get(`${API}/menu/status`, {params: {token}, ...config}),
    saveChoices: (token, choices, config) => axios.post(`${API}/menu/save?token=${token}`, {choices}, config),
};